export const navigationColorStyles = theme => ({
  coloredToolbarIcon: {
    display: 'inline-flex', alignItems: 'center', flexShrink: 0,
    '& svg': {color: 'var(--toolbar-icon-color) !important'},
  },
  languageFlag: {display: 'block', width: 24, height: 17, objectFit: 'cover', borderRadius: 3, border: `1px solid ${theme.palette.divider}`},
  languageOption: {display: 'inline-flex', alignItems: 'center', gap: 10},
});
